const my_profile = {
  viewMyClubSeacretProfile: "Ver mi perfil de ClubSeacret", // translated
  verifiedEmail: "Correo electrónico verificado", // translated
  unverifiedEmail: "E-mail no verificado", // translated
  viewMoreDetails: "Ver más detalles", // translated
};

export default my_profile;
